import type { shell as en } from '@/i18n/locales/en/shell';
import type { Translation } from '@/i18n/types';

export const shell: Translation<typeof en> = {
  notFound: {
    title: 'Page introuvable',
    body: 'Cette adresse n’existe pas.',
    backLink: 'Retour à l’aperçu',
  },
  configWarning: {
    body: '<0>Configuration incomplète.</0> {{missing}} manquant(s). Définissez-les dans <1>.env.local</1> pour le développement local (voir <2>.env.example</2>), ou dans l’environnement du conteneur pour un déploiement.',
  },
  skipToContent: 'Aller au contenu',
  brandName: 'NOLATR',
  mainNav: 'Principal',
  sectionNav: 'Section',
  accountNav: 'Compte',
  openMainMenu: 'Ouvrir le menu',
  closeMainMenu: 'Fermer le menu',
  activeCompany: 'Entreprise active',
  profileStub: {
    title: 'Profil',
    lead: 'Votre page de profil arrive bientôt — en attendant, ceci est un espace réservé pour que la coquille ait un endroit où vous envoyer.',
  },
  manageStub: {
    title: 'Gestion',
    lead: 'Choisissez une section dans le menu.',
  },
};
